import { render, staticRenderFns } from "./courseListView_new.vue?vue&type=template&id=19b4e0cc&scoped=true"
import script from "./courseListView_new.vue?vue&type=script&lang=js"
export * from "./courseListView_new.vue?vue&type=script&lang=js"
import style0 from "./courseListView_new.vue?vue&type=style&index=0&id=19b4e0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4e0cc",
  null
  
)

export default component.exports